
import 'vanilla-cookieconsent/dist/cookieconsent.css';
import * as CookieConsent from 'vanilla-cookieconsent';

// Define dataLayer and the gtag function.
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}

CookieConsent.run({
  guiOptions: {
    consentModal: {
      layout: 'cloud inline',
      position: 'bottom center',
      equalWeightButtons: true,
      flipButtons: false
    },
    preferencesModal: {
      layout: 'box',
      equalWeightButtons: true,
      flipButtons: false
    }
  },

  // Configure categories and services
  categories: {
    necessary: {
      enabled: true,  // this category is enabled by default
      readOnly: true,  // this category cannot be disabled
    },
    analytics: {
      autoClear: {
        cookies: [
          {
            name: /^_ga/,
            domain: '.nemzetiarchivum.hu'
          },
          {
            name: '_gid',
            domain: '.nemzetiarchivum.hu'
          }
        ]
      },
      services: {
        ga: {
          label: 'Google Analytics',
          onReject: () => {
            if (typeof gtag === 'function') {
              gtag('consent', 'update', { analytics_storage: 'denied' });
            }
          }
        }
      }
    }
  },

  language: {
    default: 'hu',
    translations: {
      hu: {
        consentModal: {
          title: 'A weboldal sütiket használ',
          description: `Oldalunk cookie-kat ("sütiket") használ. Ezen fájlok információkat szolgáltatnak számunkra a felhasználó oldallátogatási szokásairól, de nem tárolnak személyes információkat. Szolgáltatásaink igénybe vételével Ön beleegyezik a cookie-k használatába. További információkat <a href='/cookie-consent'>itt</a> olvashat.`,
          acceptAllBtn: 'Elfogadom mindet',
          acceptNecessaryBtn: 'Csak a szükségeset',
          showPreferencesBtn: 'Egyéni beállítások kezelése'
        },
        preferencesModal: {
          title: 'Süti beállítások kezelése',
          acceptAllBtn: 'Elfogadom mindet',
          acceptNecessaryBtn: 'Csak a szükségeset',
          savePreferencesBtn: 'Aktuális beállítások mentése',
          closeIconLabel: 'Bezárás',
          sections: [
            {
              title: "Sütik használata",
              description: "Sütiket használunk a weboldal alapvető működésének biztosítására, valamint az online élményed javítására."
            },
            {
              title: "Szigorúan szükséges sütik",
              description: "Ezek a sütik elengedhetetlenek a weboldal megfelelő működéséhez (pl. bejelentkezés, kosár tartalma).",
              linkedCategory: 'necessary',
            },
            {
              title: "Analitikai sütik",
              description: "Az analitikai sütik segítenek adatokat gyűjteni arról, hogyan használják a felhasználók az oldalt. Ezek az információk segítenek a tartalom fejlesztésében és a felhasználói élmény javításában.",
              linkedCategory: 'analytics',
              cookieTable: {
                headers: {
                  name: "Név",
                  domain: "Szolgáltatás",
                  expiration: "Lejárat"
                },
                body: [
                  {
                    name: "_ga",
                    domain: "Google Analytics",
                    expiration: "1-2 év is lehet"
                  },
                  {
                    name: "_gid",
                    domain: "Google Analytics",
                    expiration: "Munkamenet vége"
                  }
                ]
              }
            },
            {
              title: 'További információ',
              description: `További információt a <a href='/cookie-consent'>sütikezelési tájékoztató</a>nkban olvashat`
            }
          ]
        }
      }
    }
  }

});

window.CookieConsent = CookieConsent;
